import { render, staticRenderFns } from "./promotionsDetail.vue?vue&type=template&id=6a1ab5da&scoped=true&"
import script from "./promotionsDetail.vue?vue&type=script&lang=js&"
export * from "./promotionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./promotionsDetail.vue?vue&type=style&index=0&id=6a1ab5da&lang=scss&scoped=true&"
import style1 from "./promotionsDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ab5da",
  null
  
)

export default component.exports